class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    console.log('open', triggeredBy);
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    // Hide chat button when menu is open
    const chatButton = document.getElementById('gorgias-chat-container');
    if (chatButton) { chatButton.setAttribute('style', 'display: none'); };

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');

    // Show chat button when menu is open
    const chatButton = document.getElementById('gorgias-chat-container');
    if (chatButton) { chatButton.removeAttribute('style'); };
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;


    this.getSectionsToRender().forEach((section) => {
      if (section.id == 'cart-drawer') {
        const shouldReplace = ['.drawer__header', '.drawer__collection-header', '.progress-bar-container', '.drawer__collection-list', 'cart-drawer-items', '.drawer__footer'];
        const parsedCartDrawer = new DOMParser().parseFromString(parsedState.sections[section.id], 'text/html')
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);

        shouldReplace.forEach((selector) => {
          const elementToReplace = sectionElement.querySelector(selector);
          const newElement = parsedCartDrawer.querySelector(selector);
          if (elementToReplace && newElement) {
            elementToReplace.replaceWith(newElement);
          }
        });

        const drawerCollectionList = section.selector ? document.querySelector(section.selector).querySelector('.drawer__collection-list') : document.getElementById(section.id).querySelector('.drawer__collection-list');
        if (!drawerCollectionList) return;
        $(drawerCollectionList).slick({
          slidesToShow: 2,
          swipeToSlide: true,
          centerMode: drawerCollectionList.childElementCount == 1 ? false : true,
          arrows: false,
          centerPadding: '80px',
        });

        const collectionArrows = document.querySelectorAll('.drawer__collection-arrows button');
        collectionArrows.forEach(arrowButton => {
          arrowButton.addEventListener('click', function (event) {
            const direction = event.target.getAttribute('data-direction');
            if (direction === 'prev') {
              $(drawerCollectionList).slick('slickPrev');
            } else {
              $(drawerCollectionList).slick('slickNext');
            }
          });
        })

        const drawerCollectionListItems = drawerCollectionList.querySelectorAll('.card_wrapper_variants');
        drawerCollectionListItems.forEach((item) => {
          if (item.childElementCount > 5) {
            $(item).slick({
              infinite: true,
              slidesToScroll: 2,
              speed: 1000,
              arrows: true,
              slidesToShow: 4,
              prevArrow: '<svg width="24" class="slider-left" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.8584 2.15171C15.6661 1.95358 15.3495 1.94891 15.1514 2.14126C14.7843 2.49768 8.78061 8.50196 7.873 9.41277C7.41824 9.86913 6.98623 10.3034 6.66792 10.6236L6.14549 11.1493C5.9519 11.3443 5.95134 11.6596 6.14493 11.8546L6.66736 12.3803C6.98532 12.7001 7.41687 13.1339 7.87114 13.5897C8.77778 14.4995 14.7804 20.5027 15.1472 20.8588C15.3453 21.0511 15.6619 21.0464 15.8542 20.8483C16.0466 20.6501 16.0419 20.3336 15.8437 20.1412C15.4845 19.7925 9.4892 13.7967 8.57947 12.8839C8.12556 12.4284 7.6943 11.9949 7.37651 11.6752L7.20455 11.5022L7.37708 11.3286C7.69522 11.0086 8.12695 10.5746 8.58135 10.1186C9.49205 9.20472 15.4884 3.20789 15.848 2.85874C16.0461 2.66638 16.0508 2.34983 15.8584 2.15171Z" fill="#05080A"/></svg>',
              nextArrow: '<svg width="24" class="slider-right" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">  <path d="M8.14126 20.8483C8.33362 21.0464 8.65017 21.0511 8.84829 20.8587C9.2154 20.5023 15.2191 14.498 16.1267 13.5872C16.5815 13.1309 17.0135 12.6966 17.3318 12.3764L17.8542 11.8507C18.0478 11.6557 18.0484 11.3404 17.8548 11.1454L17.3323 10.6197C17.0144 10.2999 16.5828 9.86611 16.1286 9.41026C15.2219 8.50047 9.21928 2.4973 8.85252 2.14125C8.65439 1.9489 8.33784 1.95359 8.14549 2.15172C7.95314 2.34986 7.95783 2.6664 8.15597 2.85875C8.51524 3.20754 14.5105 9.20325 15.4202 10.1161C15.8741 10.5716 16.3054 11.0051 16.6232 11.3248L16.7951 11.4978L16.6226 11.6714C16.3045 11.9914 15.8727 12.4254 15.4183 12.8814C14.5076 13.7953 8.51133 19.7921 8.15171 20.1413C7.95358 20.3336 7.94891 20.6502 8.14126 20.8483Z" fill="#05080A"/></svg>',
            });
          }
        });
      } else {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    });

    const isUpsellItemDeclined = sessionStorage.getItem(window.upsellModal?.productHandle + '-is-upsell-modal-shown');
    if (window.upsellModal?.enabled && window.upsellModal?.upsellItems?.length && !isUpsellItemDeclined) {
      const upsellModal = document.getElementById('modal-upsell-wrapper');
      if (upsellModal) upsellModal.classList.remove('modal-upsell-wrapper--hidden');
      return;
    }

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    console.log('setActiveElement', element);
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);